import { UIButtonMode } from "../ui-button/ui-button-mode.enum";
import { UITextMode } from "../ui-text/ui-text-mode.enum"

export type UISpinnerStylingProps = {
    mode: UITextMode | UIButtonMode,
    size: 'small' | 'medium' | 'large'
}

export class UISpinnerStyling {
    public props: UISpinnerStylingProps;
    constructor(props: UISpinnerStylingProps = {mode: UITextMode.default, size: 'medium'}) {
        this.props = props;
    }

    

    get svgClass(): {[key: string]: boolean} {
        return {
            '≈w-4 md:≈w-5 lg:≈w-6': this.sizeIs('small'),
            '≈w-5 md:≈w-6 lg:≈w-7': this.sizeIs('medium') || !this.props.size,
            '≈w-6 md:≈w-7 lg:≈w-8': this.sizeIs('large')
        }
    }

    get circleClass(): {[key: string]: boolean} {
        return {
            '≈stroke-interactive-default': this.modeIs(UITextMode.default),
            '≈stroke-warning-borders-default': this.modeIs(UITextMode.warning),
            '≈stroke-critical-borders-default': this.modeIs(UITextMode.critical),
            '≈stroke-success-borders-default': this.modeIs(UITextMode.success),
            '≈stroke-highlight-borders-default': this.modeIs(UITextMode.highlight),
            '≈stroke-primary-actions-default': this.modeIs(UITextMode.primary),
            '≈stroke-disabled-border': this.modeIs(UITextMode.disabled),
        };
    }

    modeIs(mode: UITextMode | string): boolean {
        return mode == this.props.mode || mode == UITextMode[this.props.mode];
    }

    sizeIs(size: 'small' | 'medium' | 'large'): boolean {
        return this.props.size == size;
    }
}
